import { UiButtonModel, LinkButtonThemeModel } from "../../models";

export function mockUiButtonModel({
    id = "button-1234",
    type = "uiButton",
    locale = "en",
    content = mockUiButtonModelContent()
}: Partial<UiButtonModel> = {}): UiButtonModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiButtonModelContent = UiButtonModel["content"];

export function mockUiButtonModelContent({
    entryTitle = "Example Button",
    text = "Example button",
    url = "#example",
    ...optionals
}: Partial<UiButtonModelContent> = {}): UiButtonModelContent {
    return {
        entryTitle,
        text,
        url,
        ...optionals
    };
}

export function mockLinkButtonThemeModel({
    id = "button-theme-1234",
    type = "linkButtonTheme",
    locale = "en",
    content = mockLinkButtonThemeModelContent()
}: Partial<LinkButtonThemeModel> = {}): LinkButtonThemeModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type LinkButtonThemeModelContent = LinkButtonThemeModel["content"];

export function mockLinkButtonThemeModelContent({
    ...optionals
}: Partial<LinkButtonThemeModelContent> = {}): LinkButtonThemeModelContent {
    return {
        ...optionals
    };
}
